export default "__VITE_ASSET__CAes8O5C__"